import { FC } from "react";
import ErrorMessage from "../error-message";
import {
  FormControl,
  InputLabel,
  Select as MaterialSelect,
  MenuItem
} from "@mui/material";

import "./Select.scss";

type SelectProps = {
  options: any[];
  label?: string;
  placeholder?: string;
  selectClass?: string;
  labelClass?: string;
  errorMessage?: string;
  value: string;
  onChange: (val: any) => void;
  variant?: "filled" | "outlined" | "standard";
  minWidth?: number;
};

const Select: FC<SelectProps> = ({
  options,
  label,
  placeholder,
  selectClass,
  labelClass,
  errorMessage = "",
  value,
  onChange,
  variant = "filled",
  minWidth = 180
}: SelectProps) => {
  return (
    <FormControl
      className="select-dropdown"
      variant={variant}
      sx={{ m: 0, minWidth }}
    >
      {label && (
        <InputLabel className={labelClass} id="demo-simple-select-filled-label">
          {label}
        </InputLabel>
      )}
      <MaterialSelect
        value={value}
        onChange={onChange}
        className={selectClass}
        labelId="demo-simple-select-standard-label"
        id="demo-simple-select-standard"
        key={value}
        displayEmpty
        renderValue={(selected: any) => {
          if (selected === "" && placeholder) {
            return placeholder;
          }
          return selected;
        }}
        inputProps={{
          MenuProps: {
            MenuListProps: {
              sx: {
                backgroundColor: "#23232f",
                color: "#ffffff"
              }
            }
          }
        }}
      >
        {placeholder !== undefined && (
          <MenuItem value="" key="__placeholder__">
            {placeholder}
          </MenuItem>
        )}
        {(options || []).map((option: string) => {
          return (
            <MenuItem value={option} key={option}>
              {option}
            </MenuItem>
          );
        })}
      </MaterialSelect>
      {errorMessage && <ErrorMessage>{errorMessage} </ErrorMessage>}
    </FormControl>
  );
};

export default Select;
